import { render } from "./PromotionForm.vue?vue&type=template&id=5fd46bc3&scoped=true&ts=true"
import script from "./PromotionForm.vue?vue&type=script&lang=ts"
export * from "./PromotionForm.vue?vue&type=script&lang=ts"

import "./PromotionForm.vue?vue&type=style&index=0&id=5fd46bc3&scoped=true&lang=css"
import "./PromotionForm.vue?vue&type=style&index=1&id=5fd46bc3&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd46bc3"]])

export default __exports__